// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__mIXFU","buttons":"RemoveExpirationActionButtons_buttons__3yS_S"};